export function directusFileUrl(fileId: string): string {
  return `https://mamf-www-directus.moveapp.org/assets/${fileId}`
}

export function directusDownloadUrl(fileId: string): string {
  return `${directusFileUrl(fileId)}?download`
}
